export enum EGAlimCalculErrorTypeEnum {
  APPELLATION_SANS_ORDRE = 'APPELLATION_SANS_ORDRE',
  FAMILLE_EGALIM_MANQUANTE = 'FAMILLE_EGALIM_MANQUANTE'
}
